import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, AppStore, RootState } from "./store";

/**
 * Typed hooks for Redux
 * Use these instead of plain useDispatch and useSelector
 */

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

// Reads the live store outside of render — needed by async work that resolves after
// the component has unmounted, where a captured value or ref would be stale.
export const useAppStore = useStore.withTypes<AppStore>();
